export const timerAsync = (ms: number) => new Promise(res => setTimeout(res, ms));

